(function($) {
  "use strict";
  /* ---------------------------------------------
  SEARCH
   --------------------------------------------- */
  var $current_search = null,
      $val = '',
      $typeSearch = '',
      $url = '',
      ajaxSearch = function(element){
        $val = element.val();
        var $this = element.parents('form.box-search');
        clearTimeout($current_search);
        if (theme.function.searchByCollection) {
          if($this.find("li span.selected").attr("data-value") === "all"){
            $(".iconSearchDrop").removeClass('isFilter');
            $typeSearch = '';
          }
          else if($this.find("li span.selected").attr("data-value") === "article"){
            $(".iconSearchDrop").addClass('isFilter');
            $typeSearch = 'type=article';
          }
          else if($this.find("li span.selected").attr("data-value") === "page"){
            $(".iconSearchDrop").addClass('isFilter');
            $typeSearch = 'type=page';
          }
          else if($this.find("li span.selected").attr("data-value") === "product"){
            $(".iconSearchDrop").addClass('isFilter');
            $typeSearch = 'type=product';
          }
          else{
            $typeSearch = 'type=product';
            $(".iconSearchDrop").addClass('isFilter');
            if($this.find("li span.selected").attr("data-value") !== ''){
              $val = $this.find("ul ul li span.selected").attr('data-cll') + $this.find("input.search").val();
            }
          }
        }
        if($val.trim() == '') {
          $this.removeClass('loading bar-loading bounce loaded');
          $this.find(".livesearch").html('');
          return false;
        }else{
          $this.find(".livesearch").html('');
          $url = $typeSearch.length > 0 ? encodeURI("/search?q="+$val+"&"+$typeSearch+"&view=ajax".replace(/\s/g,'+')) : encodeURI("/search?q="+$val+"&view=ajax".replace(/\s/g,'+'));
          if (theme.function.searchByCollection) {
            $this.addClass('loading').removeClass('loaded');
          }
          else{
            $this.addClass('bar-loading bounce').removeClass('loaded');
          }
          $current_search = setTimeout(function(){
            $.get($url, function(data) {
              if($(data).find('.thumb').length === 0 ){
                if (theme.function.searchByCollection) {
                  $this.removeClass('loading').addClass('loaded');
                }
                else{
                  $this.removeClass('bar-loading bounce').addClass('loaded');
                }
                $this.find(".livesearch").html(data);
              }
              else{
                $this.find(".livesearch").html(data);
                $this.find(".item-search").each(function(i) {
                  var t = $(this);
                  var style = $(this).attr("style");
                  style = (style == undefined) ? '' : style+";";
                  var delay = i * 20 + 1 * 50;
                  var animate = t.data('animate');
                  if(i == $this.find(".item-search").length - 1){
                    if (theme.function.searchByCollection) {
                      $this.removeClass('loading').addClass('loaded');
                    }
                    else{
                      $this.removeClass('bar-loading bounce').addClass('loaded');
                    }
                  }
                })
                if ($this.find(".livesearch .shopify-product-reviews-badge").length > 0 && typeof window.SPR == 'function') {
                  return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                }
              }
              if (theme.function.multiCurrency == true && cookieCurrency !== null && cookieCurrency !== shopCurrency) {
                Currency.convertAll(shopCurrency,cookieCurrency,".livesearch span.money");
              }
            });
          },700);
        }
      };
  
  /* ---------------------------------------------
    Search By cattegories
    kitisummus@gmail.com
   --------------------------------------------- */
  function kt_search(){
    //Search Box
    $(document).on('submit', "form.box-search", function(event){
      var $this = $(this);
      if($this.find("li span.selected").attr("data-value") === "all"){
        $("input.inputType").removeAttr('name');
        return;
      }
      else if($this.find("li span.selected").attr("data-value") === "article"){
        $("input.inputType").attr({'name':'type','value':'article'});
        return;
      }
      else if($this.find("li span.selected").attr("data-value") === "page"){
        $("input.inputType").attr({'name':'type','value':'page'});
        return;
      }
      else if($this.find("li span.selected").attr("data-value") === "product"){
        $("input.inputType").attr({'name':'type','value':'product'});
        return;
      }
      else{
        $("input.inputType").attr({'name':'type','value':'product'});
        if($this.find("li span.selected").attr("data-value") !== ''){
          var inputValue = $this.find("ul ul li span.selected").attr('data-cll') + $this.find("input.search").val();
          $("input.search").val(inputValue);
        }
        return;
      }
      event.preventDefault();
    });

    $(document).on("keyup","input.search", function(event){
      event.preventDefault();
      $("input.search").not($(this)).val($(this).val());
    });

    $(document).on("click", "form.box-search .searchDrop li span", function(event){
      event.preventDefault();
      if($(this).hasClass(".titleGroup") == false){
        $("form.box-search").find(".selected").removeClass("selected");
        $(this).addClass("selected");
        var inputName = $(this).attr('data-value');
        var inputValue = $(this).parents('form.box-search').find('input.search');
        $("input.inputType").attr('value',inputName);
        if( inputValue.val().trim() != '' ){
          $(this).parents('form.box-search').removeClass('showCatt');
          ajaxSearch(inputValue);
        }
      }
    });

    //Search By cattegories
    $(document).on("focus",".box-search input.search",function(e) {
      if (theme.function.searchByCollection) {
        $(this).parents('.box-search').addClass('focus');
        if ($('.searchDrop [data-value="collection"]').length <= 0 && $('.searchDrop').data('collections-size') !== '0') {
          if (typeof(Storage) !== "undefined" && sessionStorage.dataSearchDrop !== undefined) {
            $('.searchDrop .value-product').after(sessionStorage.dataSearchDrop);
          } else {
            $.get('/collections?view=searchDrop', function(data) {
              sessionStorage.dataSearchDrop = data;
              $.each($('.searchDrop .value-product'), function(index, val) {
                $(this).after(data)
              });
            });
          }
        }
      }
    });

    $(document).on('click', '.iconSearchDrop', function(event) {
      if (theme.function.searchByCollection) {
        event.preventDefault();
        $(this).parents('.box-search').toggleClass('showCatt');
      }
    });

    $(document).on('click', 'input.search', function(event) {
      if (theme.function.searchByCollection) {
        event.preventDefault();
        $(this).parents('.box-search').removeClass('showCatt');
      }
    });
    
    $(document).on('keydown', 'input.search', function(evt){
      if(evt.which == 13) {
        jQuery('.iconSearchDrop').trigger('click');
        $(this).closest('form').submit();
      }
    });

    $(document).on('click', function(e){ 
      if ($(e.target).is('.box-search') === false && $(e.target).is('.box-search input') === false && $(e.target).is('.iconSearchDrop svg') === false && $(e.target).is('.box-search *') === false) {
        $('.box-search').removeClass('focus').removeClass('showCatt').removeClass('loaded');
        $('.livesearch').empty();
      }
    });
  }
  
  $(document)
  .on('shopify:section:load', kt_search)
  .on('shopify:section:unload', kt_search)
  .on('shopify:section:select', kt_search)
  .on('shopify:section:deselect', kt_search)
  .on('shopify:block:select', kt_search)
  .on('shopify:block:deselect', kt_search);
  
  /* ---------------------------------------------
   QUICKVIEW
   --------------------------------------------- */
  function kt_quickView(){
    $('body').on('click', '.quick-view', function(event) {
      event.preventDefault();
      var url = $(this).attr('data-view');
      var $this = $(this);
      $this.addClass('loading');
      if ($("#myModal").attr('data-view') == url) {
        $("#myModal").modal();
        return false;
      }
      $.ajax({
        url: url+'?view=quickView',
        type: 'GET',
        beforeSend:function(){
          $('.product-quickview-content').addClass('loading');
        },
        success: function(data){
          $('.product-quickview-content').html(data.split('<!-- sizeGuide_and_shipping -->')[2]);
          var sizeGuide_and_shipping = data.split('<!-- sizeGuide_and_shipping -->')[1];
          $('body').append('<div id="sizeGuide_and_shipping">'+sizeGuide_and_shipping+'</div>');
          var imgLarge = new Image();
              imgLarge.src = $('.product-quickview-content .SlickPhotoswipGallery').find('img').first().attr('src'); 
          imgLarge.onload = function () {
            $("#myModal").attr('data-view',url).modal();
            setTimeout(function() {
              var sections = new theme.Sections();
              sections.register('productQuickview', theme.Product);              
              theme.stockCountdown.init('#ProductSection-quickview-template .kt_progress_bar_pr');
              theme.DropdownReposive.init('#ProductSection-quickview-template .fake_select>ul','.color_sw','.title');
              if (theme.function.multiCurrency == true && cookieCurrency !== null && cookieCurrency !== shopCurrency) {
                Currency.convertAll(shopCurrency,cookieCurrency,'.product-quickview-content span.money');
              }
              // TweenLite.to('.line-loading', .5,{width: '100%',onComplete: function (e) {$('.test-loading').hide();TweenLite.to('.line-loading', 0, {width: 0});}});
              if ($(".product-quickview-content .shopify-product-reviews-badge").length > 0 && typeof window.SPR == 'function') {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              }
              $this.removeClass('loading');
            }, 350);
          }
        }
      });
    });
  }
  if($('.quick-view').length > 0 && theme.function.quickview){
    $(document)
    .on('shopify:section:load', kt_quickView)
    .on('shopify:section:unload', kt_quickView)
    .on('shopify:section:select', kt_quickView)
    .on('shopify:section:deselect', kt_quickView)
    .on('shopify:block:select', kt_quickView)
    .on('shopify:block:deselect', kt_quickView);
  }

  /* ---------------------------------------------
   QUICKSHOP
   --------------------------------------------- */
  function kt_quickShop(){
    $(document).on('click', '.kt__quick-shop', function(event) {
      event.preventDefault();
      var $this = $(this);
      var pr_item = $this.closest('.product-item');
      var formJS = pr_item.find('form[data-section-id]');
      var dataPStyle = pr_item.parent().hasClass('p-style-06') ? 'p-style-06' : ''
      $('body').append('<div id="qsShowUp" class="p-style-01 modalShowUp" data-p-style="'+dataPStyle+'"><div class="product-item showUp"><div class="alert-top"></div><div class="close-qs showUp" data-form="#qsShowUp"></div>'+pr_item.html()+'</div></div>');
      pr_item = $('#qsShowUp');
      pr_item.find('.product-wrapper,.product-info').removeAttr('style');
      pr_item.find('.kt__quick-shop').addClass('d-none');
      pr_item.find('.add_to_cart_button').removeClass('d-none');
      pr_item.find('form[data-section-id]').hide();
      $('#bg-overlay').attr('data-form', '#qsShowUp');

      var variants_qs = '';
      variants_qs += '<div class="product-variants-wrapper-qs">';
      variants_qs += '<form action="#" data-pr-vrs="" id="'+formJS.attr('id')+'-qs" data-section-id="'+formJS.attr('data-section-id')+'-qs" data-options="'+formJS.attr('data-options')+'">';
      variants_qs += formJS.find('[data-opt="Opt1Js"]').length ? formJS.find('[data-opt="Opt1Js"]')[0].outerHTML : '';
      variants_qs += formJS.find('[data-opt="Opt2Js"]').length ? formJS.find('[data-opt="Opt2Js"]')[0].outerHTML : '';
      variants_qs += formJS.find('[data-opt="Opt3Js"]').length ? formJS.find('[data-opt="Opt3Js"]')[0].outerHTML : '';
      variants_qs += formJS.find('[name="id"]')[0].outerHTML;
      variants_qs += formJS.find('[name="quantity"]')[0].outerHTML;
      variants_qs += '</form>';
      variants_qs += '</div>';
      pr_item.find('.product-inner').append(variants_qs);
      pr_item.find('.product-variants-wrapper-qs ul._small').removeClass('_small');
      pr_item.find('ul.product-loop-variants').css("cssText", "display: inline-block !important;");
      pr_item.find('.add_to_cart_button').css("cssText", "display: block !important;position: fixed;bottom: 0;right: 0;left: 0;z-index: 1;max-width: 768px");

      var img_container = pr_item.find('.product-thumb');
      $(img_container).css({position: 'absolute',top:'-75px',width: '120px',borderRadius: '5px','boxShadow': '0 0 1rem rgba(0, 0, 0, 0.15)'});
      $('#qsShowUp').css('position','fixed');
      anime({targets: '#qsShowUp',duration: 0,easing: 'linear',bottom:'-100%',left: '50%',backgroundColor: '#fff',zIndex: 1042,width: '100%',maxWidth: '480px',minHeight: '250px',
        complete: function(anim) {
          pr_item.addClass('showUp');
          $('#bg-overlay').addClass('showUp');
          if ($(window).width() < 768) {
            $(pr_item).animate({bottom: 0}, 500);
          }
          else{
            $(pr_item).animate({bottom: '50%'}, 500);
          }
          $this.removeClass('loading');

          $('body').css({overflow:'hidden',marginRight: getScrollbarWidth()});
        }});
    });
  }

  /* ---------------------------------------------
   PRODUCT GRID ADD MORE
   --------------------------------------------- */
  KT.addmoreGrid = (function(){
    function init(elem) {
      $('#amShowUp').remove();
      var $this = elem;
      if ($this.closest('.product-item').length) {
        var pr_item = $this.closest('.product-item');
        if (pr_item.hasClass('showUp')) {
          Shopify.KT_addItemFromForm(pr_item.find('form[data-section-id]').attr('id') + '-qs');
          $this.addClass('adding').text(theme.strings.addingToCart+' ...');
          return false;
        }
        var formJS = pr_item.find('form[data-section-id]');
        var url = $this.attr('data-view');
        var crVr = $this.attr('data-vrid');
        var fea_image = $this.closest('.product-item').find('.product-thumb .primary-thumb').attr('data-ogr');
      }
      if ($this.hasClass('product-variable__cart-drawer')) {
        var formJS = $this.closest('.item__cart-drawer').find('form[data-section-id]');
        var url = $this.attr('data-view');
        var crVr = $this.attr('data-vrid');
        var fea_image = $this.attr('data-ogr');
        theme.MenuReposive.is_mobile() ? $('.close__cart-drawer').trigger('touchstart') : $('.close__cart-drawer').trigger('click');
      }
      $('body').append('<div id="amShowUp" class="p-style-01 modalShowUp"><div class="close-qs showUp" data-form="#amShowUp"></div><div id="amShowUpJSON" data-featured-image="'+fea_image+'"></div>'+theme.variantsAddMore.init(formJS,url,crVr)+'</div>');
      pr_item = $('#amShowUp');
      $('#bg-overlay').attr('data-form', '#amShowUp');
      pr_item.css({'position':'fixed' ,bottom:'-100%',left: '50%'});
      anime({targets: '#amShowUp',duration: 0,delay: $this.hasClass('product-variable__cart-drawer') ? 500 : 0,easing: 'linear',backgroundColor: '#fff',zIndex: 1042,width: '100%',maxWidth: '768px',minHeight: '250px',
        complete: function(anim) {
          pr_item.addClass('showUp');
          $('#bg-overlay').addClass('showUp');
          if ($(window).width() < 768) {
            pr_item.animate({bottom: 0}, 500);
          }
          else{
            pr_item.animate({bottom: '50%'}, 500);
          }
          $this.removeClass('loading');
          $('body').css({overflow:'hidden',marginRight: getScrollbarWidth()});
        }
      });
      $(document).on('change', '.qty[name="quantity"]',function() {
        var qty = $(this).val();
        var price = parseInt($(this).attr('data-price'));
        $(this).closest('tr').find('.price ins').html(theme.Currency.formatMoney(price*qty, theme.moneyFormat));        
        if (theme.function.multiCurrency == true && cookieCurrency !== null && cookieCurrency !== shopCurrency) {
          Currency.convertAll(shopCurrency,cookieCurrency,'#amShowUp .list-vrs span.money');
        }
      });
    }
    function on_click() {
      $(document).on('click','#amShowUp .btn-addmore', function(event){
        var prVrs = $('#amShowUpJSON').data('pr-vrs');
        theme.variantsAddMore.buildSelect(prVrs,parseInt($(this).attr('data-vrid')));
      });
      $(document).on('click','#amShowUp .change-d', function(event){
        $(this).closest('tr').toggleClass('chane-d-ed');
      });
    }
    return {init:init,on_click:on_click};
  })();

  function getScrollbarWidth() {
    var $inner = jQuery('<div style="width: 100%; height:200px;">test</div>'),
        $outer = jQuery('<div style="width:200px;height:150px; position: absolute; top: 0; left: 0; visibility: hidden; overflow:hidden;"></div>').append($inner),
        inner = $inner[0],
        outer = $outer[0];
    jQuery('body').append(outer);
    var width1 = inner.offsetWidth;
    $outer.css('overflow', 'scroll');
    var width2 = outer.clientWidth;
    $outer.remove();
    return (width1 - width2);
  }
  
  /* ---------------------------------------------
   REGISTER PAGE
   --------------------------------------------- */
  function customize_error(){
    $('#error_html .errors').detach().appendTo('.error_html_clone');
  }
  $(document)
  .on('shopify:section:load', customize_error)
  .on('shopify:section:unload', customize_error)
  .on('shopify:section:select', customize_error)
  .on('shopify:section:deselect', customize_error)
  .on('shopify:block:select', customize_error)
  .on('shopify:block:deselect', customize_error);
  
  /* ---------------------------------------------
   WISHLIST
   --------------------------------------------- */
  // Add wishlist
  function addwishlist() {
    $("body").on('click', '.add_nitro_wishlist', function(event) {
      event.preventDefault();
      var $this = $(this),
          holder = $this.parent().siblings('.kt-wl-add-button'),
          load = $this.parent().find('.load_nitro_wishlist'),
          added = $this.parent().find('.added_nitro_wishlist');
      $this.hide();
      load.show();
      $.ajax({
        url: 'https://nitro-wishlist.teathemes.net?shop='+ Shopify.shop,
        type: 'POST',
        data: $this.data(),
        success: function(data, status) {
          try {
            data = $.parseJSON(data);
          } catch(ex) {
            //console.log(ex);
          }
          if(data.status == 'success' && status == 'success') {
            added.show();
            load.hide();
            $this.hide();
            $('.gl_count_wishlist').html(function(i, val) {
              return val * 1 + 1
            });
          } else {
            load.hide();
            $this.show();
            console.log('ajax error');
          }
        },
        error: function(data) {
          load.hide();
          $this.show();
          console.log('ajax error');
        },
      });
    });
  }
  // Remove wishlist
  function removewishlist() {
    $("body").on('click', '.nitro_wishlist_remove', function(event) {
      event.preventDefault();
      var $this = $(this),
          value = $(this).data('id');
      $('.wishlist-page .card').css('opacity','1');
      $.ajax({
        url: 'https://nitro-wishlist.teathemes.net?shop='+ Shopify.shop,
        type: 'POST',
        data: $this.data(),
        success: function(data, status) {
          try {
            data = $.parseJSON(data);
          } catch(ex) {
            //console.log(ex);
          }
          if(data.status == 'success' && status == 'success') {
            $('.gl_count_wishlist').html(function(i, val) {
              return val * 1 - 1
            });
            $('#WishItem-' + value).fadeOut(300, function(){
              $(this).remove();
              var rowCount = $('.wishlist-page-items .wishlist-page-item').length;
              if(rowCount == 0) {
                $('.wishlist-page-items')
                .html('<div class="col-md-12"><div class="text-center wishlist-empty">' + theme.wishlist.nowishlist + '</div></div>');
              }
            });
            $('.wishlist-page .card').css('opacity','0');
          } else {
            $('.loader').remove();
            console.log('ajax error');
          }
        },
        error: function(data) {
          $('.loader').remove();
          console.log('ajax error');
        },
      });
    });
  }
  
  /* ---------------------------------------------
   RECENTLY VIEWED
   --------------------------------------------- */
  // Add to recently
  function recentlyViewedAdd() {
    var arrayProduct = localStorage.getItem("kt-recent") !== null ? localStorage.getItem("kt-recent").split(',') : new Array;
    if(product_handle !== null){
      var c = _handleize(product_handle);
      if(arrayProduct.indexOf(c)< 0 ){
        if(arrayProduct.length >= 10){
          arrayProduct.pop();
        }
        arrayProduct[arrayProduct.length]= (c);
        arrayProduct = arrayProduct.toString();
        localStorage.setItem("kt-recent", arrayProduct);
      }
    }
  }
  // recentlyViewedListSidebar
  window.recentlyViewedListSidebar = function() {
    if($('.widget_recent_product').length > 0){
      var stringProduct = localStorage.getItem("kt-recent") || '';
      if(localStorage.getItem("kt-recent") !== null){
        var arrayProduct = stringProduct.split(',');
        var arrayProduct = arrayProduct.reverse();
        $(".widget_recent_product").show();
        $.ajax({
          url: '/pages/recently-viewed-products/'+arrayProduct.join(",")+'?q=list-sidebar',
          dataType: 'html',
          type: 'GET',
          success: function(responsive) {
            //console.log(responsive);
            if(responsive.indexOf('<!-- recently-viewed-products -->') >= 0){
              $('.widget_recent_product .product-categories').html(responsive);
            }
          },
          error: function(data) {
            console.log('ajax error');
          },
          complete: function() {
            //currency            
            if (theme.function.multiCurrency == true && cookieCurrency !== null && cookieCurrency !== shopCurrency) {
              Currency.convertAll(shopCurrency,cookieCurrency,'.product-categories li span.money');
            }
            //product review
            if ($(".spr-badge").length > 0 && typeof window.SPR == 'function') {
              return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
            }
          }
        });
      }
    }    
  }
  // recentlyViewedProductSingle
  window.recentlyViewedProductSingle = function() {
    if($('.widget_recent_productSg').length > 0){
      var stringProduct = localStorage.getItem("kt-recent") || '';
      var arrayProduct = stringProduct.split(',');
      if(localStorage.getItem("kt-recent") !== null){
        var arrayProduct = arrayProduct.reverse();
        $.ajax({
          url: '/pages/recently-viewed-products/'+arrayProduct.join(",")+'?q='+product_id+'+'+collectionRecently,
          dataType: 'html',
          type: 'GET',
          success: function(responsive) {
            // console.log(responsive);
            $('.widget_recent_productSg .owl-carousel').trigger('destroy.owl.carousel');
            if(responsive.length > 43 && responsive.indexOf('<!-- recently-viewed-products -->') >= 0){
              $('.widget_recent_productSg .owl-carousel').html(responsive);
              $(".widget_recent_productSg").show();
            }
          },
          error: function(data) {
            console.log('ajax error');
          },
          complete: function() {
            var $this = $('.widget_recent_productSg .owl-carousel');
            var config = $this.data();
            if ($this.hasClass('.no-overflow') && $this.children().length > config.items + 2) {
              config.loop = true;
            } else {
              $this.removeClass('no-overflow');
            }
            config.navText = ['<i class="btn btn-primary fa fa-caret-left"></i>','<i class="btn btn-primary fa fa-caret-right"></i>'];
            config.navElement = 'div';
            
            if ($this.parent().hasClass('owl-content-fix')) {
              config.navContainer = "."+$this.parent().find('.nav-fix').attr('data-nav');
            }
            var owl = $this;
            KT.loadScript('owl-carousel', function(e,l){
              if (l == 'ok') {
                owl.owlCarousel(config);
                owl.on('resized.owl.carousel', function(event) {
                  theme.checkProductGrid_Width();
                })
              }
            })

            //currency            
            if (theme.function.multiCurrency == true && cookieCurrency !== null && cookieCurrency !== shopCurrency) {
              Currency.convertAll(shopCurrency,cookieCurrency,'.widget_recent_productSg li span.money');
            }
            theme.checkProductGrid_Width();
            //product review
            if ($(".widget_recent_productSg .spr-badge").length > 0 && typeof window.SPR == 'function') {
              return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
            }
          }
        });
      }
    }
  }
  $(document)
  .on('shopify:section:load', recentlyViewedProductSingle)
  .on('shopify:section:unload', recentlyViewedProductSingle)
  .on('shopify:section:select',recentlyViewedProductSingle)
  .on('shopify:section:deselect', recentlyViewedProductSingle)
  .on('shopify:block:select',recentlyViewedProductSingle)
  .on('shopify:block:deselect', recentlyViewedProductSingle);
  
  /* ---------------------------------------------
   SPECIAL ITEMS SIDEBAR
   --------------------------------------------- */
  window.specialItemsProductSingle = function() {
    var $this = $('.product-sidebar .owl-carousel');
    if ($this.length <= 0) {return false;}
    var config = $this.data();
    var owl = $this;

    KT.loadScript('owl-carousel', function(e,l){
      if (l == 'ok') {
        owl.owlCarousel(config);
        owl.on('resized.owl.carousel', function(event) {
          theme.checkProductGrid_Width();
        })
      }
    })
  }
  $(document)
  .on('shopify:section:load', specialItemsProductSingle)
  .on('shopify:section:unload', specialItemsProductSingle)
  .on('shopify:section:select',specialItemsProductSingle)
  .on('shopify:section:deselect', specialItemsProductSingle)
  .on('shopify:block:select',specialItemsProductSingle)
  .on('shopify:block:deselect', specialItemsProductSingle);

  /* ---------------------------------------------
   COMPARE
   --------------------------------------------- */
  function AutoloadCompare(){
    var stringProduct = localStorage.getItem("kt-compare");
    if(stringProduct != null){ 
      var arrayProduct = stringProduct.split(',');
      arrayProduct.map(function(index, elem) {
        $(".compare[data-pid='"+index+"']").addClass('added');
      });
    }
  }
  function AddCompare(){
    $('body').on('click', '.compare', function(event) {
      event.preventDefault();
      if($(this).hasClass('added') && $("#compare-content").find('.product-description').length > 0){
        $("#compare-modal").modal('show');
        return false;
      }
      /* Act on the event */
      var $this = $(this),
          handle = $this.data('pid'),
          holder = $("#compare-content"),
          stringProduct = localStorage.getItem("kt-compare");
      $this.addClass('loading');
      if(stringProduct != null && stringProduct.length > 1){ 
        var arrayProduct = stringProduct.split(',');
      }else{
        var arrayProduct = new Array;
      }
      if(arrayProduct.indexOf(handle)< 0 && $(this).hasClass('added') === false ){
        arrayProduct.push(handle);
        if (arrayProduct.length > 1) {
          var arrayProduct_ = arrayProduct.join(',');
          if (arrayProduct_.substring(0, 1) == ',') { 
            arrayProduct_ = arrayProduct_.substring(1);
          }
        }else{
          arrayProduct_ = arrayProduct.toString();
        }
        localStorage.setItem("kt-compare", arrayProduct_);
      }
      KT.showModalCompare(handle);
      setTimeout(function() {
        $this.removeClass('loading').addClass('added');
      }, 1000);
    });
  }
  function RemoveCompare(){
    $('body').on('click', '#compare-content .product-remove', function(event) {
      event.preventDefault();
      /* Act on the event */
      var $this = $(this),handle = $this.attr('data-pid');
      $('.compare[data-pid="'+handle+'"]' ).removeClass('added');
      var stringProduct = localStorage.getItem("kt-compare");      
      if(stringProduct != null){ 
        var arrayProduct = stringProduct.split(',');
      }
      arrayProduct = jQuery.grep(arrayProduct, function(value) {
        return value != handle;
      });
      arrayProduct = $.trim(arrayProduct);
      localStorage.setItem("kt-compare", arrayProduct);
      anime({targets: '.cp-'+handle, opacity: 0,duration: 300,easing: 'linear',complete: function(anim) {$('.cp-'+handle).remove()}});
      if(arrayProduct.length === 0 ){}
    });
  }
  KT.showModalCompare = function(p_handle){
    if($("#compare-content").find('.'+p_handle).length > 0){
      $("#compare-modal").modal('show');
      return false;
    }
    $("#compare-content td").remove();
    var list_handle = localStorage.getItem("kt-compare").split(',');
    $("#compare-content").css({'overflow-y':'auto','max-height':$(window).outerHeight() - 30});
    list_handle.map(function(index, elem) {
      if (index !== '' && index !== null) {
        Shopify.KT_getProduct(index,function(data){
          $("#compare-content .tr-remove").append('<td class="product-remove cp-'+data.handle+'" data-pid="'+data.handle+'" ><a href="#" class="remove">'+theme.compare.remove+'</a></td>');
          var html = '';
          html +='<td class="product-images cp-'+data.handle+'"><img src="'+Shopify.KT_resizeImage(data.featured_image,"250x250_crop_center")+'" alt="'+data.title+'">';
          html +='<h3 class="product-name"><a href="'+data.url+'">'+data.title+'</a></h3>';
          html +='<span class="price">';
          html +='<ins>'+theme.Currency.formatMoney(data.price, theme.moneyFormat)+'</ins>';
          if(data.compare_at_price > data.price ){
              html +='<del>'+theme.Currency.formatMoney(data.compare_at_price, theme.moneyFormat)+'</del>';
          }
          html +='</span><span class="clearfix"></span>';
          if(data.variants.length > 1){
              html +='<a class="add-to-cart btn btn-primary btn-sm" href="'+data.url+'">'+theme.productStrings.selectOption+'</a>';
          }else{
              if(data.available){
                  html +='<a href="javascript:void(0);" title="'+theme.productStrings.addToCart+'" class="add-to-cart btn btn-primary btn-sm" onclick="$(this).addClass(\'loading\').removeClass(\'loaded\');Shopify.KT_addItem('+data.variants[0].id+',1)">'+theme.productStrings.addToCart+'</a>';
              }else{
                  html +='<a class="add-to-cart btn btn-primary btn-sm" href="'+data.url+'">'+theme.productStrings.soldOut+'</a>';
              }
          }

          html +='</td>';
          $("#compare-content .tr-product-image").append(html);
          $("#compare-content .tr-product-desc").append('<td class="product-description cp-'+data.handle+' text-left"><div class="description">'+(data.description.split('[/short description]')[0].replace('[short description]','')).replace(/(<([^>]+)>)/ig,"").substring(0, 300)+'</div></td>');
          $("#compare-content .tr-availability").append('<td class="product-availability cp-'+data.handle+'">'+( data.available ? "<span class=\"in-stock\">"+theme.productStrings.inStock+"</span>" : "<span class=\"in-stock\">"+theme.productStrings.outOfStock+"</span>")+'</td>');
        });
      }
    })
    setTimeout(function() {
      if(theme.function.multiCurrency == true && cookieCurrency !== null && cookieCurrency !== shopCurrency){
        Currency.convertAll(shopCurrency,cookieCurrency,'#compare-content span.money');
      }
      $("#compare-modal").modal('show');
    }, 1000);
  }

  /* ---------------------------------------------
   Responsive item slide
   --------------------------------------------- */  
  function responsive_item_slide(){
    var responsived = '';
    $('.slideshow__slide[data-slide-blockid]').each(function(){
      var responsive = $.parseJSON($(this).attr('data-responsive').replace(/\s/g,' '));
      var responsiveSubtitle = $.parseJSON($(this).attr('data-responsive-subtitle').replace(/\s/g,' '));
      var responsiveDesc = $.parseJSON($(this).attr('data-responsive-description').replace(/\s/g,' '));
      var blockId = $(this).attr('data-slide-blockid');
      if ($(".css-"+blockId).length <= 0) {
        $.map(responsive, function(e, i) {
          if (e != ''){
            responsived = responsived + '@media only screen and (min-width: '+i+'px){'+ '.slideshow__slide--'+blockId +' .slideshow__title{'+ e +'}}';
          }
        })
        $.map(responsiveSubtitle, function(e, i) {
          if (e != ''){
            responsived = responsived + '@media only screen and (min-width: '+i+'px){'+ '.slideshow__slide--'+blockId +' .slideshow__subtitle{'+ e +'}}';
          }
        })
        $.map(responsiveDesc, function(e, i) {
          if (e != ''){
            responsived = responsived + '@media only screen and (min-width: '+i+'px){'+ '.slideshow__slide--'+blockId +' .slideshow__description{'+ e +'}}';
          }
        })
        $(this).closest('[data-section-id]').addClass('css_builded');
      }
    })
    if ($('.css_slider_builded').length == 0) {
      $('head').append('<style type="text/css" class="css_slider_builded">'+(responsived.replace(/\"/g,''))+'</style>');
    }else{
      $('.css_slider_builded').html(responsived.replace(/\"/g,''))
    }
  }
  $(document)
  .on('shopify:section:load', responsive_item_slide)
  .on('shopify:section:unload', responsive_item_slide)
  .on('shopify:section:select',responsive_item_slide)
  .on('shopify:section:deselect', responsive_item_slide)
  .on('shopify:block:select',responsive_item_slide)
  .on('shopify:block:deselect', responsive_item_slide);

  /* ---------------------------------------------
   ACCOUNT FORM ERORR
   --------------------------------------------- */
  function customize_error(){
    $('#error_html .errors').detach().appendTo('.error_html_clone');
  }
  $(document)
  .on('shopify:section:load', customize_error)
  .on('shopify:section:unload', customize_error)
  .on('shopify:section:select', customize_error)
  .on('shopify:section:deselect', customize_error)
  .on('shopify:block:select', customize_error)
  .on('shopify:block:deselect', customize_error);

  /* ---------------------------------------------
   NEWSLETTER POPUP
   --------------------------------------------- */
  function checkCookieNewsletterPopup() {
    var display = getCookie("kt_popupNewsletter");
    var delay = $('#newsletterModal').attr('data-pause');
    var mobileDisplay = $('#newsletterModal').attr('data-mobile-display');
    if($('#contact_form p.form--success').length <= 0){
      if(mobileDisplay === 'true' && theme.MenuReposive.is_mobile() === true && $(window).width() < 768){
        $('#newsletterModal').remove();
      }else{
        $('#hideforever').change(function(){
          if ($(this).is(':checked')) {
            document.cookie = "kt_popupNewsletter=disable;1;path=/";
          } else {
            document.cookie = "kt_popupNewsletter=;path=/";
          }
        });
        if (display != "disable") {
          setTimeout(function() {
            $('#newsletterModal').modal('show');
            setCookie("kt_popupNewsletter",'disable',1,1,delay);
          }, 500);
        }
      }
    }
  }

  function register($form) {
    $form.find('[id|="mc-embedded-subscribe"]').text(theme.strings.nll_send);
    $form.find('.close__').hide();
    $.ajax({
      type: $form.attr('method'),
      url: $form.attr('action'),
      data: $form.serialize(),
      cache: false,
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      error: function (err) { alert(theme.strings.nll_error_mesenger) },
      success: function (data) {
        console.log($form)
        $form.find('[id|="mc-embedded-subscribe"]').text($form.find('[id|="mc-embedded-subscribe"]').data('value'));
        if (data.result === 'success') {
          // Yeahhhh Success
          // console.log(data.msg)
          $form.find('.msg.error').remove();
          $('.kt-popup-newsletter .notice').hide();
          if ($form.find('.msg.success').length > 0) {
            $form.find('.msg.success').html((theme.strings.nll_success_mesenger).replace('<span class=\"code\"></span>', '<span class=\"code\">'+$form.attr('data-kt')+'</span>'));
          }else{
            $form.prepend('<p class="msg success margin-bottom-10" style="color: rgb(53, 114, 210)">'+(theme.strings.nll_success_mesenger).replace('<span class=\"code\"></span>', '<span class=\"code\">'+$form.attr('data-kt')+'</span>')+'</p>')
          }
        } else {
          // Something went wrong, do something to notify the user.
          // console.log(data.msg)
          $form.find('.msg.success').remove();
          if ($form.find('.msg.error').length > 0) {
            $form.find('.msg.error').html(data.msg.substring(4))
          }else{
            $form.find('form').prepend('<p class="msg error margin-bottom-10" style="color: #ff8282;margin-top: 15px;">' + data.msg.substring(4) + '</p>')
          }
        }
      }
    })
  }  
  /* ---------------------------------------------
   LIGHT WICTH DARK
  --------------------------------------------- */
  function swicthLight(){
    function switch_(){
      var logo_url = $('header .logo img').first().length > 0 ? $('header .logo img').first().attr('src') : '';
      var logo_size = theme.Images.imageSize(logo_url) !== null ? '_'+theme.Images.imageSize(logo_url) : '';
      if ($('body').hasClass('styleDarken')) {
        $('body,header .header-wrap-stick,footer').css('background-color', '#111');
        $('header .logo img').attr('src', logo_url.replace(logo_size+'.svg','_light'+logo_size+'.svg').replace(logo_size+'.jpg','_light'+logo_size+'.jpg').replace(logo_size+'.png','_light'+logo_size+'.png'));
        $.each($('img[alt="img_switch"]'), function(el, idx) {
          var _url = $(this).attr('src');
          var _size = theme.Images.imageSize(_url) !== null ? '_'+theme.Images.imageSize(_url) : '';
          $(this).attr('src', _url.replace(_size+'.svg','_light'+_size+'.svg').replace(_size+'.jpg','_light'+_size+'.jpg').replace(_size+'.png','_light'+_size+'.png'));
        });
      }else{
        $('body,header .header-wrap-stick,footer').css('background-color', '');
        $('header .logo img').attr('src', logo_url.replace(logo_size+'_light',logo_size+''));
        $.each($('img[alt="img_switch"]'), function(el, idx) {
          var _url = $(this).attr('src');
          var _size = theme.Images.imageSize(_url) !== null ? '_'+theme.Images.imageSize(_url) : '';
          $(this).attr('src', _url.replace('_light'+_size,_size));
        });
      }
    }
    function onClick(){
      $(document).on('click', '.light-action', function(e){
        e.preventDefault();
        var $this = $(this);
        $this.css('pointer-events', 'none');
        $('body,header,footer').toggleClass('styleDarken');
        switch_();
        var theme_light = $('body').hasClass('styleDarken') ? 'drak' : 'light';
        $.ajax({
          type: "POST",
          url: '/cart.js',
          data: {"attributes[theme_light]": theme_light},
          dataType: 'json',
          success: function() {
            $this.css('pointer-events', '');
          }
        });
      });
    }
    return {
      switch: switch_,
      onClick: onClick
    };
  }

  /* ---------------------------------------------
   CART DRAWER
  --------------------------------------------- */
  KT.drawOpen = function(){
    $('body').addClass('cart-drawer-open');
    $('#bg-overlay').addClass('cart-drawer-overlay').removeClass('menu-overlay');
    $('body').css({overflow:'hidden',marginRight: getScrollbarWidth()});
    if($('#bg-overlay').hasClass('showUp')){
      $('#amShowUp').addClass('mini')
    }
    KT.drawResize();
  }
  KT.drawResize = function(){
    var wHeight = $(window).height();
    var headHeight = $('.head__cart-drawer').outerHeight();
    var footHeight = $('.footer__cart-drawer').outerHeight();
    var height = wHeight-(headHeight+footHeight+17);
    if (height > 350) {
      $('.items__cart-drawer').css('max-height',height);
    }else{
      $('.items__cart-drawer').css('max-height',350);
    }
  }

  /* ---------------------------------------------
   OVERLAY DROPDOWN
   --------------------------------------------- */
  function overlayDropdown(){
    var desktop = function(e) {
      $(document).on('mouseenter','[data-overlay="kt-dropdown"]',function(){
        if ($('#bg-overlay').hasClass('menu-overlay') == false && $('#bg-overlay').hasClass('showUp') == false) {
          $('#bg-overlay').addClass('menu-overlay');
        }
      })
      $(document).on('mouseleave', '[data-overlay="kt-dropdown"]',function(){
        if ($('#bg-overlay').hasClass('menu-overlay')) {
          $('#bg-overlay').removeClass('menu-overlay')
        }
      })
    }
    var touch = function(e) {
      $(document).on('touchstart','[data-overlay="kt-dropdown"]',function(){
        if ($('#bg-overlay').hasClass('menu-overlay') == false && $('#bg-overlay').hasClass('showUp') == false) {
          $('#bg-overlay').addClass('menu-overlay')
        }
      })
      $(document).on('touchstart', function(e){
        if ($(e.target).is('[data-overlay="kt-dropdown"] *') === false && $('#bg-overlay').hasClass('menu-overlay')) {
          $('#bg-overlay').removeClass('menu-overlay');
        }
      })
    }
    // $(window).width() >= $('#header .main-navigation').data('width') ? 
    return theme.MenuReposive.is_mobile() ? touch() : desktop();
  }

  /* ---------------------------------------------
   BACKGROUND OVERLAY
  --------------------------------------------- */
  KT.bgOverlay = function(action){
    $(document).on(action, '#bg-overlay,.close-qs,.close__cart-drawer', function(e){
      var $this = $(this);
      if ($this.hasClass('showUp')) {
        var pr_item = $($this.attr('data-form'));
        $('body').css({overflow:'',marginRight: ''});
        anime({targets: '#bg-overlay.showUp', backgroundColor: 'rgba(0,0,0,0)',duration: 300,easing: 'linear'})
        anime({targets: $this.attr('data-form'), bottom: '-50%',opacity: 0,duration: 300,easing: 'linear',complete: function(anim) {
          $('body').removeClass('popIn');
          $('#bg-overlay').removeAttr('style class data-form');
          $('.showUp:not(#bg-overlay)').removeAttr('data-form');
          pr_item.remove();
        }});
      }
      if ($this.hasClass('cart-drawer-overlay') || $this.attr('data-form') === "cart-drawer") { 
        $('body').removeClass('cart-drawer-open');
        $('body').css({overflow:'',marginRight: ''});
        anime({targets: '#bg-overlay.cart-drawer-overlay', backgroundColor: 'rgba(0,0,0,0)',duration: 300,easing: 'linear',complete: function(anim) {
          $('#bg-overlay').removeAttr('style class');
        }})
      }
    });
  }

  /* ---------------------------------------------
   ERROR ALERT
  --------------------------------------------- */
  KT.errorAlert = function(content){
    $('.cart-error .content-error').html(content);
    $('.cart-error').addClass('show');
  }

  /* ---------------------------------------------
   GET ANIMATE
  --------------------------------------------- */
  KT.getAnimationDuration = function(el) {
    var cssTimingProps = ['animation-duration', 'transition-duration'],
      durations = {};
    for (var i = 0, len = cssTimingProps.length; i < len; i++) {
      var key = String(cssTimingProps[i]),
        compStyle = window.getComputedStyle(el, null),
        trans = compStyle.getPropertyValue(key);
      if (trans && trans !== '0s') {
        durations[key] = [];

        var transItems = trans.toLowerCase().split(',');
        for (var j = 0, lenJ = transItems.length; j < lenJ; j++) {
          var duration = transItems[j];

          if (duration.indexOf('ms') !== -1) {
            duration = duration.replace('ms', '');
            durations[key][j] = parseFloat(duration);
          } else {
            duration = duration.replace('s', '');
            durations[key][j] = parseFloat(duration) * 1000;
          }
        }
      }
    }
    return durations;
  }

  /* ---------------------------------------------
   FIX GRID STYLE 1
   --------------------------------------------- */
  function fixGridStyle_1(){
    $('body')
    .on('mouseenter','.p-style-01:not(.showUp) .product-wrapper,.p-style-03:not(.showUp) .product-wrapper',function(event) {
      if ($(this).closest('.product-item').width() >= 230 && $(window).width() > 1200) {
        var this_info = $(this).find('.product-info');
        $(this).css('height', $(this).height());
        this_info.css({marginTop: this_info.height()*-1});
        $(this).find('.product-thumb .product-button-wrapper').css({bottom: this_info.height()});
      }
    })
    .on('mouseleave','.p-style-01:not(.showUp) .product-wrapper,.p-style-03:not(.showUp) .product-wrapper',function(event) {
      if ($(this).closest('.product-item').width() >= 230 && $(window).width() > 1200) {
        var $this = $(this)        
        $this.find('.product-thumb .product-button-wrapper').css({bottom: ''});
        anime({targets: $this.find('.product-info'), marginTop: 0,duration: 0,easing: 'linear',complete: function(anim) {
          $this.find('.product-info').removeAttr('style');
          anime({targets: $this,height: 'auto',delay: 600,easing: 'linear',complete: function(anim) {
            $this.removeAttr('style');
          }});
        }});
      };
    });    
    $('body')
    .on('mouseenter','.owl-carousel-fix-on-hover',function(event) {
      $(this).addClass('on-hover').css({'width': $(this).width(),'height': $(this).height()});
      if ($(this).find('.owl-stage-outer').length > 0) {
        $(this).addClass('on-hover').css({'margin-bottom': 30});
        $(this).find('.owl-stage-outer').css({'padding':'30px 30px 200px', 'margin':'-30px -30px -200px', 'z-index': 1});
      }
    })
    .on('mouseleave','.owl-carousel-fix-on-hover',function(event) {
      $(this).removeClass('on-hover').css({'width': '','height': '','margin-bottom':''});
      $(this).find('.owl-stage-outer').css({'padding':'', 'margin':'', 'z-index': 1});
    })
  }

  /* ---------------------------------------------
   FIX SWATCH STYLE
   --------------------------------------------- */
  KT.fixGridSwatch = function(){
    $('.color_pick.swatch, [data-usecolor="true"] .swatch').each(function( index ) {
      if(getComputedStyle(this).backgroundColor === 'rgba(0, 0, 0, 0)' && getComputedStyle(this).backgroundImage === 'none'){
        $(this).addClass('no_background')
      }
    });
  }

  /* ---------------------------------------------
   FIX SEARCH ICON 2
   --------------------------------------------- */
  KT.fixSearchIcon2 = function(){
    if ($('.resize-header-search-icon2').length) {    
      $('.resize-header-search-icon2').each(function( index ) {  
        var mirror = $(this).offset();
        var search_icon = $(this).closest('.header').find('.box-search.show-icon.style2 .icon-link').offset();
        var width = $(this).width();
        $(this).closest('.header').find('.box-search.show-icon.style2 .inner').css({
          'max-width': width + (search_icon.left - (mirror.left + width)) - 30,
          'width': '100%',
          'left': mirror.left + 15,
          'top': search_icon.top,
          'position': 'fixed'
        });
      });

      $(document)
      .on('mouseenter', '.header.style-02.style-11 .box-search.show-icon.style2', function(event) {
        event.preventDefault();
        $('.main-navigation').css('opacity', '0');
      })
      .on('mouseleave', '.header.style-02.style-11 .box-search.show-icon.style2', function(event) {
        event.preventDefault();
        $('.main-navigation').css('opacity', '1');
      });
    }
  }

  /* ---------------------------------------------
   MOUSE POSITION
   --------------------------------------------- */
  KT.moveItem = function(el) {  
    var lFollowX = 0,
    lFollowY = 0,
    x = 0,
    y = 0,
    friction = 1 / 30;
    function moveBackground(elem) {
      x += (lFollowX - x) * friction;
      y += (lFollowY - y) * friction;
      
      var translate = 'translate(' + x + 'px, ' + y + 'px)';
      // console.log(translate)
      $(el+' .bg').css({
        '-webit-transform': translate,
        '-moz-transform': translate,
        'transform': translate
      });

      // window.requestAnimationFrame(moveBackground);
    }
    $(el).on('mousemove', function(e) {
      var offset = $(el).offset();
      var lMouseX = Math.max(-100, Math.min(100, $(el).width() / 2 - e.clientX));
      var lMouseY = Math.max(-100, Math.min(100, $(el).height() / 2 - e.clientY));
      lFollowX = (20 * lMouseX) / 100; // 100 : 12 = lMouxeX : lFollow
      lFollowY = (20 * lMouseY) / 100;
      moveBackground(el);
    });
  }  
  
  /* ---------------------------------------------
   PARALLAX BANNER
   --------------------------------------------- */
  KT.parallax = function(){
    KT.loadScript('parallax', function(e,l){
      if (l == 'ok') {
        //parallax
        var window_size = $(window).width();
        window_size += getScrollbarWidth();
        $('.bg-parallax').each(function(){
          theme.MenuReposive.is_mobile() === true ? $(this).addClass('isMoblideParallax') : $(this).removeClass('isMoblideParallax'); 
          if( window_size > 991 ){
            $(this).parallax('50%', parseFloat($(this).attr('data-parallax-speed')));
          }
        });
        if($('.block-paralax3 .bg-parallax_child1').length > 0){
          $('.block-paralax3 .bg-parallax_child1').parallax('10%', 0.2);
        }
      }
    })
  }
  $(document)
  .on('shopify:section:load', KT.parallax)
  .on('shopify:section:unload', KT.parallax)
  .on('shopify:section:select', KT.parallax)
  .on('shopify:section:deselect', KT.parallax)
  .on('shopify:block:select', KT.parallax)
  .on('shopify:block:deselect', KT.parallax);

  /* ---------------------------------------------
   RESPONSIVE SPACE SECTION
   --------------------------------------------- */
  function respSpaceSection(){
    var resp_0 = '',resp_1 = '',resp_2 = '',resp_3 = '',resp_4 = '',resp_5 = '';
    // 0, 576px, 768px, 992px, 1200px, 1230px
    var query0 = "screen and (min-width: 0px)",
        query1 = "screen and (min-width: 576px)",
        query2 = "screen and (min-width: 768px)",
        query3 = "screen and (min-width: 992px)",
        query4 = "screen and (min-width: 1200px)",
        query5 = "screen and (min-width: 1230px)",
    respSpace = function(el,count){
      var resp_ = el.data('el') + '{';
      if (el.data('margin-t-responsive') !== undefined && el.data('margin-t-responsive') !== '') {
        var mt = el.data('margin-t-responsive').split('|');
        resp_ += mt[count] !== undefined ? 'margin-top:' + mt[count] + ' !important;' : '';
      }
      if (el.data('margin-b-responsive') !== undefined && el.data('margin-b-responsive') !== '') {
        var mb = el.data('margin-b-responsive').split('|');
        resp_ += mb[count] !== undefined ? 'margin-bottom:' + mb[count] + ' !important;' : '';
      }
      if (el.data('padding-responsive') !== undefined && el.data('padding-responsive') !== '') {
        var p = el.data('padding-responsive').split('|');
        if (el.data('el-p') == undefined) {
          resp_ += p[count] !== undefined ? 'padding:' + p[count] + ' !important;' : '';
          resp_ === el.data('el') + '{' ? resp_ = '' : resp_ += '}';
        } else if(p[count] !== undefined) {
          resp_ === el.data('el') + '{' ? resp_ = '' : resp_ += '}';
          resp_ += el.data('el-p') + '{';
          resp_ += p[count] !== undefined ? 'padding:' + p[count] + ' !important;' : '';
          resp_ += '}';
        } else {
          resp_ === el.data('el') + '{' ? resp_ = '' : resp_ += '}';
        }
      } else {
       resp_ === el.data('el') + '{' ? resp_ = '' : resp_ += '}';
      }
      return resp_; 
    },
    handler0 = {
        match : function() {
          $.each($('[data-el]'), function(index, el) {
            resp_0 += respSpace($(this),0);
          });
          resp_0 = resp_0 !== '' ? '@media ' + query0 + '{' + resp_0 + '}' : '';
        },
        destroy : function() {}
    },
    handler1 = {
        match : function() {
          $.each($('[data-el]'), function(index, el) {
            resp_1 += respSpace($(this),1);
          });
          resp_1 = resp_1 !== '' ? '@media ' + query1 + '{' + resp_1 + '}' : '';
        },
        destroy : function() {}
    },
    handler2 = {
        match : function() {
          $.each($('[data-el]'), function(index, el) {
            resp_2 += respSpace($(this),2);
          });
          resp_2 = resp_2 !== '' ? '@media ' + query2 + '{' + resp_2 + '}' : '';
        },
        destroy : function() {}
    },
    handler3 = {
        match : function() {
          $.each($('[data-el]'), function(index, el) {
            resp_3 += respSpace($(this),3);
          });
          resp_3 = resp_3 !== '' ? '@media ' + query3 + '{' + resp_3 + '}' : '';
        },
        destroy : function() {}
    },
    handler4 = {
        match : function() {
          $.each($('[data-el]'), function(index, el) {
            resp_4 += respSpace($(this),4);
          });
          resp_4 = resp_4 !== '' ? '@media ' + query4 + '{' + resp_4 + '}' : '';
        },
        destroy : function() {}
    },
    handler5 = {
        match : function() {
          $.each($('[data-el]'), function(index, el) {
            resp_5 += respSpace($(this),5);
          });
          resp_5 = resp_5 !== '' ? '@media ' + query5 + '{' + resp_5 + '}' : '';
        },
        destroy : function() {}
    };
    enquire.register(query0, handler0, true);
    enquire.register(query1, handler1, true);
    enquire.register(query2, handler2, true);
    enquire.register(query3, handler3, true);
    enquire.register(query4, handler4, true);
    enquire.register(query5, handler5, true);
    if ($('style.respSpaceSection') .length) {
      $('.respSpaceSection').html(resp_0+resp_1+resp_2+resp_3+resp_4+resp_5);
    }else{
      $('head').append('<style media="screen" class="respSpaceSection">'+resp_0+resp_1+resp_2+resp_3+resp_4+resp_5+'</style>');
    }
  }
  
  /* ---------------------------------------------
   SCROLL
   --------------------------------------------- */
  // left: 37, up: 38, right: 39, down: 40,
  // spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
  var keys = {37: 1, 38: 1, 39: 1, 40: 1};

  window.preventDefault = function(e) {
    e = e || window.event;
    if (e.preventDefault)
        e.preventDefault();
    e.returnValue = false;  
  }

  window.preventDefaultForScrollKeys = function(e) {
    if (keys[e.keyCode]) {
      preventDefault(e);
      return false;
    }
  }

  window.disableScroll = function(e) {
    if (window.addEventListener) // older FF
        window.addEventListener('DOMMouseScroll', preventDefault, false);
    window.onwheel = preventDefault; // modern standard
    window.onmousewheel = document.onmousewheel = preventDefault; // older browsers, IE
    window.ontouchmove  = preventDefault; // mobile
    document.onkeydown  = preventDefaultForScrollKeys;
  }

  window.enableScroll = function(e) {
    if (window.removeEventListener)
        window.removeEventListener('DOMMouseScroll', preventDefault, false);
    window.onmousewheel = document.onmousewheel = null; 
    window.onwheel = null; 
    window.ontouchmove = null;  
    document.onkeydown = null;  
  }

  window.setCookie = function(cname, cvalue, exdays, exhours, exminute) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * exhours * exminute * 60 * 1000));
    var expires = (exminute == 0 ? 1 : "expires="+d.toUTCString());
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  window.getCookie = function(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  /* ---------------------------------------------
     Scripts ready
   --------------------------------------------- */
  $(document).ready(function() {
    kt_search();
    kt_quickView();
    kt_quickShop();
    if (theme.function.use_am_popup) {
      KT.addmoreGrid.on_click();
    }
    customize_error();
    addwishlist();
    removewishlist();
    if($('.widget_recent_product').length > 0 || $('#ProductSection-product-template').length > 0){
      recentlyViewedAdd();
    }
    responsive_item_slide();
    theme.MenuReposive.is_mobile() ? KT.bgOverlay('touchstart') : KT.bgOverlay('click');
    respSpaceSection();
    AutoloadCompare();
    AddCompare();
    RemoveCompare();
    specialItemsProductSingle();
    swicthLight().switch();    
    KT.moveItem('.bg-pattern');
    KT.fixSearchIcon2();

    if($('.bg-parallax').length > 0){
      KT.parallax();
    }

    var windowScroll = 0;
    if($('.p-style-01').length > 0 || $('.p-style-03').length > 0 || $('.p-style-02').length > 0){
      // fixGridStyle_1();
    }

    // Scroll top Top
    $(document).on('click','.scrollToTop',function() {
      $('body,html').animate({scrollTop:0},800);
    });

    // CART DRAWER
    $(document)
    .on('focusin', '#CartSpecialInstructions' ,function(){
      $('.note__cart-drawer').addClass('show');
      $('.note__cart-drawer .update').show();
    })
    .on('click', '.note__cart-drawer .update' ,function(){
      Shopify.KT_updateCartNote($('#CartSpecialInstructions').val(),Shopify.KT_updatedCartNote);
    })
    .on('click', 'input.kt_agree' ,function(){
      if ($(this).is(':checked')) {
        $('.kt_agree_swich').css({'opacity':1,'pointer-events':''});
      }else{
        $('.kt_agree_swich').css({'opacity':'0.2','pointer-events':'none'});
      }
    })

    // BOX SEARCH
    var $val_input = null;
    $(document).on('keyup','.box-search input.search', function(event) {
      event.preventDefault();
      $val_input = $(this).val();
      ajaxSearch($(this))
    });
    
    // BOX MOBILE MENU
    $(document).on('click', '.menu-toggle', function (e) {
      e.preventDefault();
      $('.box-mobile-menu').addClass('open');
    });
    
    // VERTICAL MENU
    $(document).on('click', '.menu-desktop-toggle', function (e) {
      e.preventDefault();
      $('body').toggleClass('openVerticalMenu');
      $('.vertical-menu').toggleClass('open');
      if ($('.vertical-menu').hasClass('open')) {        
        setTimeout(function(){
          theme.DropdownReposive.init('.kiti--DropWindow','.kiti--DropItem','.kiti--DropInner');
        }, 300)
      }
    });
    
    // VERTICAL CATEGORIES
    $(document).on('click', '.header-category-toggle', function (e) {
      e.preventDefault();
      $('body').toggleClass('openCategoryHeader');
      $('.header-categoy-menu').toggleClass('open');
    });


    // SCROLL TOP
    $(document).on('click','.scroll_top',function() {
      $('body,html').animate({scrollTop:0},800);
    });

    // Right to Left
    $(document).on('click', '.rtl-action', function(e){
      e.preventDefault();
      var $this = $(this);
      $this.css('pointer-events', 'none');
      $this.attr('ogr-title',$this[0].innerHTML);
      if ($('html').attr('dir') === 'ltr') {
        $('html').attr('dir','rtl');
        $(".swacth-title,.rtl_fix").each(function( index ) {
          $this[0].innerHTML = $this[0].innerHTML.replace('(', '&rlm;(');
        });
      } else {
        $('html').attr('dir','ltr');
        $(".swacth-title,.rtl_fix" ).each(function( index ) {
          $this[0].innerHTML = $this.attr('ogr-title');
        });
      }
      $.ajax({
        type: "POST",
        url: '/cart.js',
        data: {"attributes[theme_align]": $('html').attr('dir')},
        dataType: 'json',
        success: function() {
          $this.css('pointer-events', '');
        }
      });
      setTimeout(function(){
        theme.ResizeNavMega.init();
        theme.ResizeNavMega.init('header-ontop');
        theme.DropdownReposive.init('.kiti--DropWindow','.kiti--DropItem','.kiti--DropInner');
        theme.DropdownReposive.init('#ProductSection-product-template .fake_select>ul','.color_sw','.title');  
        theme.DropdownReposive.init('.drop-resp__grid-list','.color_sw','.title');
      },400)
      setTimeout(function(){
      theme.MenuReposive.js_right_follow('#header');
      theme.MenuReposive.js_right_follow('#header-ontop');
      },600)
    });

    $(document).on('click', '.clear-attrCart-action', function(e){
      e.preventDefault();
      var $this = $(this);
      $this.css('pointer-events', 'none');
      $.ajax({
        type: "POST",
        url: '/cart.js',
        data: {
          "attributes": {
            "theme_align":'',
            "theme_light":'',
          }
        },
        dataType: 'json',
        success: function() {
          window.location.reload();
        }
      });
    });

    $(document)
    .on('click', '.btn.play', function(e) {
      $(this).closest('.product-page').find('video.video-element').trigger('play');
    });
    
    $(document)
    .on('click', '.fake_select label', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if($(this).parents('.fake_select').hasClass('show')){
        $('.fake_select.show').removeClass('show');
      }else{
        $('.fake_select.show').removeClass('show');
        $(this).parents('.fake_select').addClass('show');
      }
    })
    .on("click", function(e) {
      if ($(e.target).is('.fake_select') === false) {
        $('.fake_select').removeClass("show");
      }
    });
    
    // Filter on click
    $(document)
    .on('click', '.kt_filterGroupItem .layered_subtitle_heading', function(e){
      e.preventDefault();
      e.stopPropagation();
      if($(this).parents('.kt_filterGroupItem').hasClass('show')){
        $('.kt_filterGroupItem.show').not('.showAny').removeClass('show');
      }
      else{
        $('.kt_filterGroupItem.show').removeClass('show');
        $(this).parents('.kt_filterGroupItem').addClass('show');
      }
    })
    .on('click', function(e){
      if ($(e.target).is('.kt_filterGroupItem *') === false ) {
        $('.kt_filterGroupItem').removeClass("show");
      }
      if ($(e.target).is('.kt_dropdown .kt_layerfilterGroups') === false) {
        $('.kt_dropdown .kt_layerfilterGroups').slideUp();
      }
      if ($(e.target).is('.showQuickShop *') === false) {
        $('.showQuickShop button.close').trigger('click');
      }
    });
    

    $(document)
    .on('click', '.filter-by.filterDrop', function(e){
      e.preventDefault();
      e.stopPropagation();
      $(this).toggleClass('opened');
      $('.kt_dropdown .kt_layerfilterGroups').is(':hidden') ? $('.kt_dropdown .kt_layerfilterGroups').slideDown('slow')  : $('.kt_dropdown .kt_layerfilterGroups').slideUp();
    })
    .on('click', '.filter-by.filterCanvas', function(e){
      e.preventDefault();
      e.stopPropagation();
      $('body').toggleClass('filterOpened');
      $('.kt_canvas .kt_layerfilterGroups .bg-overlay').remove();
      $('.kt_canvas .kt_layerfilterGroups').append('<div class="bg-overlay"></div>');
      anime({targets: '.kt_canvas .kt_layerfilterGroups .bg-overlay',duration: 300, easing: 'linear','opacity': 1});
    })
    .on('click', '.kt_canvas .kt_layerfilterGroups .bg-overlay, .kt_canvas button.close', function(e){
      e.preventDefault();
      e.stopPropagation();
      $('.kt_canvas .kt_layerfilterGroups > div:first-child').css('margin-left', '-330px');
      anime({targets: '.kt_canvas .kt_layerfilterGroups .bg-overlay',duration: 300, easing: 'linear','opacity': 0,complete: function(anim) {
        $('body').removeClass('filterOpened');
        $('.kt_canvas .kt_layerfilterGroups .bg-overlay').remove();
        $('.kt_canvas .kt_layerfilterGroups > div:first-child').css('margin-left', '');
      }});      
    })
    .on('click', '.hide-sidebar', function(e){
      $('.row .main-content').animate({'-ms-flex': '100%','flex': '100%','max-width': '100%'}, 500);
      anime({targets: '.sidebar',duration: 500, easing: 'linear','-ms-flex': '0%','flex': '0%','max-width': '0%', 'padding': '0px', 'opacity': 0, 'overflow': 'hidden', 'border-color': 'transparent',complete: function(anim) {
        theme.checkProductGrid_Width();
        $('.product-listing .lazyloaded').addClass('lazyload');
        if($('.ly__ms').length > 0){
          var $grid = $('#Masory-collection-template.ly__ms_items').isotope({
            itemSelector: '.grid-item',
            masonry: {
              horizontalOrder: true,
              percentPosition: true
            },
            transitionDuration: '.5s'
          });
        }
      }});
      $('.filter-by.filterShow').removeClass('d-none');
    })
    .on('click', '.filter-by.filterShow', function(e){
      anime({targets: '.row .main-content',duration: 500, easing: 'linear','-ms-flex': '75%','flex': '75%','max-width': '75%'})
      anime({targets: '.sidebar',duration: 500, easing: 'linear','-ms-flex': '25%','flex': '25%','max-width': '25%', 'padding': '15px', 'opacity': 1, 'overflow': '', 'border-color': '',complete: function (anim) {
        $('.row .main-content').removeAttr('style');
        $('.sidebar').removeAttr('style');
        theme.checkProductGrid_Width();
        $('.product-listing .lazyloaded').addClass('lazyload');
        if($('.ly__ms').length > 0){
          var $grid = $('#Masory-collection-template.ly__ms_items').isotope({
            itemSelector: '.grid-item',
            masonry: {
              horizontalOrder: true,
              percentPosition: true
            },
            transitionDuration: '.5s'
          });
        }
      }});
      $(this).addClass('d-none');
    })
    .on('click', '.filter-by.filterMobile, #filterApply, .headFilter .close', function(e){
      e.preventDefault();
      e.stopPropagation();
      if($('.kt_layerFilter.kt_layerMobilde').hasClass('show')){
        $('.kt_layerFilter.kt_layerMobilde.show').removeClass('show');
      }
      else{
        $('.kt_layerFilter.kt_layerMobilde').addClass('show');
      }
    });
    
    // Create an event listener to set a specific variant option when clicking on swatches.
    $(document).on('click', '[data-change-option]', function(e) {      
      //Single product page    
      var templateSinglePr = 'product-template';
      if($(this).parents('.product-page').length > 0){
        templateSinglePr = $(this).parents('.product-page').attr('data-section-id');
      }
      e.preventDefault();
      goto = true;
      optionIndex = $(this).data('change-option');
      optionValue = $(this).data('value');
      $(this).parent().find('li').removeClass('selected');
      $(this).addClass('selected');
      $("#ProductSection-"+templateSinglePr+" #"+optionIndex).val(optionValue).trigger('change');
      $("#ProductSection-"+templateSinglePr+" label[data-change-label='"+optionIndex+"'] .text").html(optionValue);
      $("#ProductSection-"+templateSinglePr+" .swatches-selected-name[data-change-label='"+optionIndex+"'] .name").html(optionValue);
      $('#ProductSection-'+templateSinglePr+' .fake_select.show').removeClass('show');
    });

    $(document).on('click', '.js-set-photo-item', function(e) {
      var left = $(this).attr('data-change');
      var item_current = parseInt($(this).closest('.imagecontainer').find('.imagecontainer-wrapper').attr('data-active-item'));
      $(this).closest('.imagecontainer').find('.js-set-photo-item').removeClass('active');
      if ($(this).hasClass('photo-items__arrow_next')) {
        var next_photo = $(this).closest('.imagecontainer').find('.photo-items__dot-item').eq(item_current).next();
        left = next_photo.length <= 0 ? 0 : next_photo.attr('data-change');
        item_current = next_photo.length <= 0 ? 0 : ++item_current;
        next_photo.addClass('active');
      }
      else if ($(this).hasClass('photo-items__arrow_prev')) {
        var prev_photo = $(this).closest('.imagecontainer').find('.photo-items__dot-item').eq(item_current).prev();
        left = prev_photo.length <= 0 ? $(this).closest('.imagecontainer').find('.photo-items__dot-item').last().attr('data-change') : prev_photo.attr('data-change');
        item_current = prev_photo.length <= 0 ? parseInt($(this).closest('.imagecontainer').find('.photo-items__dot-item').last().attr('data-item')) : --item_current;
        prev_photo.addClass('active');
      }
      else{
        $(this).addClass('active');
        item_current = parseInt($(this).attr('data-item'));
      }
      var photo_container = $(this).closest('.imagecontainer').find('.imagecontainer-wrapper');
      photo_container.find('.imagecontainer-img').removeClass('active');
      photo_container.find('.imagecontainer-img').eq(item_current).addClass('active');
      photo_container.attr('data-active-item', item_current).css('left', left);
    });

    $('a[data-toggle="list"]').on('shown.bs.tab', function (e) {
      // console.log($(this).attr('href'))
      setTimeout(function(){
        theme.checkProductGrid_Width();
      }, 400);
    })
    $(document).on('click', '.tab-list-ajax [data-toggle="list"]', function(e) {
      var tab_content = $(this).closest('.tab-list-ajax').find('.tab-content');
      if ($($(this).attr('href')).find('.product-list-grid').hasClass('lazyload') ) {
        tab_content.find('.pulse-container').css('opacity', '1');
        var height = tab_content.height();
        tab_content.css('height', height);
        $($(this).attr('href')).find('.button-loadmore').css('opacity', '0');
      }
    });
    $.each($('.tab-list-ajax .product-list-grid.lazyload'), function(el, idx) {
      var component = this;
      // Modify the request headers when the targeted component kicks off an XHR
      component.addEventListener('lazyincludeload', function(event) {
        var $this = $(this)
        if (event.detail) {
          if ($this.hasClass('owl-loaded') && $this[0].hasAttribute('data-currentinclude') == false) {
            var owl = $this;
            owl.trigger('destroy.owl.carousel').removeClass('owl-loaded');
            owl.find('.owl-stage-outer').children().unwrap();
          }
        }
      });

      // Transform a JSON response into HTML before it is injected
      component.addEventListener('lazyincludeloaded', function(event) {
        if (event.detail.content) {
          setTimeout(function(){
            theme.checkProductGrid_Width();
          }, 400);
          setTimeout(function(){
            $('.tab-list-ajax').find('.tab-content').css('height', '');
            $('.tab-list-ajax').find('.pulse-container').css('opacity', '');
            theme.Carousel.init($(event.srcElement).closest('[data-section-id]')[0]);
            theme.Carousel.initCarouselMobile($(event.srcElement).closest('[data-section-id]')[0]);
            var countLimit = $(event.srcElement).attr('data-include').split('limit_')[1].split('+')[0];
            if ($(event.srcElement).find('li.grid-item').length >=parseInt(countLimit)) {
              $(event.srcElement).parent().find('.button-loadmore').css('opacity', '1');
            }
          }, 500);
        }
      });
    });

    var windowScroll = 0;
    $('.modal').on('shown.bs.modal', function () {
      // will only come inside after the modal is shown
      if($('.modal:visible').length == 1){
        $('body').css({'overflow':'hidden','position':'','left':'','right': ''});
      }else{
        $('body').css({'overflow':'hidden','position':'','left':'','right': ''});
      }
    });
    $('.modal').on('hide.bs.modal', function () {
      // will only come inside after the modal is shown
      var padding_right = 0;
      if($('.modal:visible').length > 1){
        padding_right = theme.getScrollbarWidth;
        $('body').css({'overflow':'hidden','position':'','left':'','right':'','padding-right':padding_right});        
        setTimeout(function(){
          $('body').addClass('modal-open');
        }, 401)
      }else{
        $('body').css({'overflow':'','position':'','left':'','right': '','margin-top':''});
      }
    });
  });  
  /* ---------------------------------------------
   Scripts initialization
   --------------------------------------------- */
  $(window).load(function() { 
    // if($('#instafeed, #instafeed_1').length > 0){
    //   $('#instafeed li:empty, #instafeed_1 li:empty').remove();
    //   $('#instafeed, #instafeed_1').removeClass('hidden');
    // }
  });
    
  document.addEventListener("DOMContentLoaded", function(event) {
    if($('[data-overlay="kt-dropdown"]').length > 0){
      overlayDropdown();
    }
    var dataScrollNewsletterPopup = parseInt($('#newsletterModal').attr('data-scroll'));
    if( dataScrollNewsletterPopup == 0 ){
      checkCookieNewsletterPopup();
    }

    $('[id|="mc-embedded-subscribe-form"]').each(function(){
      var $form = $(this);
      if ($form.length > 0 && theme.function.nll_ajax) {
        $form.find('[type="submit"]').bind('click', function (event) {
          if (event) event.preventDefault()
          register($form)
        })
      }
    });
    recentlyViewedProductSingle();
    KT.fixGridSwatch();
    swicthLight().onClick();
    var check_lag = window.location.search;
    if (check_lag.indexOf('lag=') > 0) {
      var cur_lag = check_lag.split('lag=')[1].split('?')[0].split('&')[0];
      $('a[href]').each(function(){
        if (($(this).attr('href')).split('/').length > 1 ){
          if (($(this).attr('href')).indexOf('?') > 0) {
            $(this).attr('href',$(this).attr('href')+ '&lag=' + cur_lag);
          } else {
            $(this).attr('href',$(this).attr('href')+ '?lag=' + cur_lag);
          }
        }
      });
    }

//     var mutationObserver = new MutationObserver(function(mutations) {
//       mutations.forEach(function(mutation) {
//         // console.log(mutation)
//         // if (mutation.target.className !== '' && (mutation.target.className).split(' ').indexOf('lazyload') > 0) {
//         //   console.log('hihni')
//         // }
//       });
//     });
// ﻿
//     mutationObserver.observe(document.documentElement, {childList: true, subtree: true, attributes: true});
  });

  /* ---------------------------------------------
   Scripts scroll
   --------------------------------------------- */
  $(window).scroll(function() {
    // Show hide scrolltop button
    var windowHeight = $(window).height();
    if($(this).scrollTop() > windowHeight ) {
      $('.scroll_top').fadeIn(500);
    } else {
      $('.scroll_top').fadeOut(800);
    }
    // Show hide newletter
    var dataScrollNewsletterPopup = parseInt($('#newsletterModal').attr('data-scroll'));
    if( $(window).scrollTop() >= dataScrollNewsletterPopup && dataScrollNewsletterPopup != 0 ){
      checkCookieNewsletterPopup();
    }
  });
  
  /* ---------------------------------------------
   Scripts resize
   --------------------------------------------- */
  $(window).on("resize", function() {
    if($('[data-overlay="kt-dropdown"]').length > 0){
      overlayDropdown();
    }
    theme.MenuReposive.is_mobile() ? KT.bgOverlay('touchstart') : KT.bgOverlay('click');
    respSpaceSection();
    KT.drawResize();
    if ($(window).width() <= 768) {
      $('.modalShowUp').animate({bottom: 0}, 500);
    }
    else{
      $('.modalShowUp').animate({bottom: '50%'}, 500);
    }
    KT.fixSearchIcon2();
  });

})( jQuery );